import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  Input,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { MyWorkHistoryItem } from '@app/core/types/work/work.types';
import { AnimationController } from '@ionic/angular';

const GREEN_BAR = 'var(--c-color-hour-progress)';
const GOLD_BAR = 'var(--c-color-hour-progress-full)';
const SPARKLE_COUNT = 8;
const DURATION = 1000;
const MAXIMUM_WORKING_HOURS = 38;

@Component({
    selector: 'c-work-progress-bar',
    templateUrl: './work-progress-bar.component.html',
    styleUrls: ['./work-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class WorkProgressBarComponent implements AfterViewInit {
  @Input() historyItem: MyWorkHistoryItem;

  @ViewChildren('sparkles') sparkles: QueryList<ElementRef>;
  @ViewChild('bar') bar: ElementRef;

  sparkleCount = new Array(SPARKLE_COUNT);

  constructor(private animationController: AnimationController) {}

  ngAfterViewInit(): void {
    const calculatedBar = 45 + this.calculatedPercentage * 1.8;
    this.animationController
      .create()
      .addElement(this.bar.nativeElement)
      .duration(DURATION)
      .iterations(1)
      .fromTo('transform', 'rotate(45deg)', `rotate(${calculatedBar}deg)`)
      .fromTo('borderBottomColor', GREEN_BAR, this.complete ? GOLD_BAR : GREEN_BAR)
      .fromTo('borderRightColor', GREEN_BAR, this.complete ? GOLD_BAR : GREEN_BAR)
      .play();

    if (this.complete) {
      for (let i = 0; i < SPARKLE_COUNT; i++) {
        const calculateScale = i % 1.11;
        this.animationController
          .create()
          .addElement(this.sparkles.toArray()[i].nativeElement)
          .delay(DURATION)
          .duration(200 + i * 50)
          .iterations(1)
          .keyframes([
            { offset: 0, transform: 'scale(0)' },
            { offset: 0.3 + (i % 0.4), transform: `scale(${calculateScale})` },
            { offset: 1, transform: 'scale(0)' },
          ])
          .play();
      }
    }
  }

  get calculatedPercentage(): number {
    return Math.min(this.historyItem?.workedHours, MAXIMUM_WORKING_HOURS) * (100 / MAXIMUM_WORKING_HOURS);
  }

  get complete(): boolean {
    return this.historyItem?.workedHours >= MAXIMUM_WORKING_HOURS;
  }

  get workedHours(): string {
    return `${Math.floor(this.historyItem?.workedHours)}`;
  }

  get workedMinutes(): string {
    const minutes = Math.round((this.historyItem?.workedHours - Math.floor(this.historyItem?.workedHours)) * 60);
    return `${minutes}`;
  }
}
